import { Component, Inject, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Subscription, timer } from "rxjs";

export interface otpVerifyPopupData {
    mainHeading: string,
    subHeading: string,
    infoMessage?: string,
    infoMessageType?: string,
    mobileNumber?: string,
    email?: string,
    submitButtonText: string,
    BackButtonText: string,
    popupType: string
}

@Component({
    templateUrl: './otp-verify-popup.html',
    styleUrls: ['./otp-verify-popup.scss']
})
export class OtpVerifyPopupComponent implements OnInit {
    @Input() initialTime: number = 30;
    @Output() resendClicked: EventEmitter<void> = new EventEmitter<void>();

    private matDialogRef: MatDialogRef<OtpVerifyPopupComponent>;
    public data: otpVerifyPopupData;
    public otpDigits = [1, 2, 3, 4, 5, 6];
    public otp: number[] = [null, null, null, null, null, null];
    public timerValue: number = 0;
    private subscription: Subscription | undefined;

    constructor(
        matDialogRef: MatDialogRef<OtpVerifyPopupComponent>,
        @Inject(MAT_DIALOG_DATA) data: otpVerifyPopupData
    ) {
        this.matDialogRef = matDialogRef;
        this.data = data;
    }

    ngOnInit(): void {
        this.startTimer();
    }

    ngOnDestroy() {
        this.stopTimer();
    }

    private startTimer() {
        this.timerValue = this.initialTime;
        this.subscription = timer(0, 1000).subscribe(() => {
            this.timerValue--;
            if (this.timerValue === 0) {
                this.stopTimer();
            }
        });
    }

    private stopTimer() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    onBackButtonClicked() {
        this.matDialogRef.close();
    }

    onVerifyClicked() {
        const enteredOtp = this.otp.join('');
        return this.matDialogRef.close(enteredOtp);
    }

    OnResendOtpClicked() {
        this.resendClicked.emit();
        this.startTimer();
    }

    isVerifyButtonDisabled(): boolean {
        return this.otp.some(digit => digit === null);
    }

    focusNext(index: number): void {
        if (index < this.otpDigits.length && this.otp[index]) {
            const nextInput = document.getElementById(`otp-input-${index + 1}`);
            if (nextInput) {
                nextInput.focus();
            }
        }
    }
}